const translations = {
  en: {
    appName: 'LiftLab',
    light: 'Light',
    dark: 'Dark',
    signOut: 'Sign out',
    logExercise: 'Log exercise',
    advanced: 'RIR',
    exercisePlaceholder: 'Exercise (e.g. Bench Press)',
    reps: 'Reps',
    minutes: 'Min',
    trackingWeighted: 'Weight',
    trackingTimed: 'Time',
    min: 'min',
    kg: 'kg',
    rest: 'Rest (s)',
    rir: 'RIR',
    addSet: '+ Set',
    saveExercise: 'Save exercise',
    todaysWorkout: "Today's workout",
    finishWorkout: 'Finish workout',
    workoutComplete: 'Workout complete',
    reopen: 'Reopen',
    deleteWorkout: 'Delete',
    addSets: 'Add sets',
    addSet2: 'Add set',
    history: 'History',
    exercises: 'exercises',
    sets: 'sets',
    workouts: 'Workouts',
    totalExercises: 'Exercises',
    totalSets: 'Sets',
    programBuilder: 'Program builder',
    muscleGuide: 'Muscle map',
    aiAnalysis: 'AI analysis',
    progress: 'Progress',
    bodyweight: 'Bodyweight',
    bodyweightSubtitle: 'Log your weight and see the trend over time.',
    bodyweightRecent: 'Recent',
    bodyweightEmpty: 'No bodyweight logged yet.',
    bodyweightGoal: 'Goal',
    bodyweightGoalType: 'Type',
    bodyweightGoalTarget: 'Target',
    bodyweightGoalMaintain: 'Maintain',
    bodyweightGoalCut: 'Cut',
    bodyweightGoalBulk: 'Bulk',
    bodyweightGoalSave: 'Save goal',
    bodyweightSave: 'Save',
    activeProgram: 'Active program — what are you training today?',
    logManually: 'Log manually today',
    removeProgram: 'Remove program',
    editProgram: 'Edit program',
    programSaved: 'Program saved. Pick a day when you train.',
    front: 'Front',
    back: 'Back',
    topExercises: 'Top exercises',
    addToHomeScreen: 'Add to Home Screen',
    selectWorkout: 'Select a previous workout',
    cancel: 'Cancel',
    loadPreviousWorkout: 'Load previous workout',
    repsLabel: 'Prescription:',
    prTrackerTitle: 'PR tracker',
    prTrackerSubtitle: 'Your latest personal records.',
    prAdd: 'Add',
    prClose: 'Close',
    prThisWeek: 'This week',
    prWeeklyGoal: 'Weekly goal',
    prUnit: 'PRs',
    prNone: 'No PRs yet — complete a set and we’ll record your best lifts.',
    prToastTitle: 'New personal best',
    prDeleteAria: 'Delete PR',
    prFormExercise: 'Exercise',
    prFormReps: 'reps',
    prFormSave: 'Save',
    showMore: 'Show more',
    showLess: 'Show less',
    navTrain: 'Train',
    navProgress: 'Progress',
    navProgram: 'Program',
    saved: 'Saved',
    saving: 'Saving…',
    incomplete: 'Incomplete',
    sessionTime: 'Session time',
    restTimer: 'Rest',
    skipRest: 'Skip',
    defaultRest: 'Rest timer',
    share: 'Share',
    shareFailed: 'Could not share',
    addExercise: 'Add exercise',
    deleteExercise: 'Remove exercise',
    completeSet: 'Complete set',
    uncompleteSet: 'Undo set',
    removeSet: 'Remove set',
    previous: 'Prev',
    set: 'Set',
    goBack: 'Back',
    dragExercise: 'Drag to reorder',
    primaryMuscle: 'Primary muscle',
    primaryMuscleOptional: 'Primary muscle (optional)',
    weeklyVolume: 'Weekly volume',
    vsLastWeek: 'vs last week',
    noLastWeek: 'No previous week to compare',
    last7: '7 days',
    last30: '30 days',
    muscleDistribution: 'Muscle distribution',
    setsPerMuscle: 'Sets per muscle',
    muscleEmpty: 'Log a few sets to see how your training is distributed.',
    restDone: 'Rest over — next set',
    save: 'Save',
    restDayLabel: 'Rest day',
    currentProgram: 'Your program',
    programSince: 'Saved',
    trainingToday: 'Today',
    trainThisDay: 'Train this day',
    replaceProgram: 'Build a new program',
    exerciseProgress: 'Exercise progression',
    viewProgram: 'Program',
    changeDay: 'Change day',
    searchGoogle: 'Search Google',
    guideStart: 'Start',
    guideMid: 'Mid',
    guideEnd: 'End',
    guideEquipment: 'Equipment',
    guideCredit: 'Exercise artwork by Everkinetic, expanded by Bryl Lim, CC BY-SA 4.0.',
    recapVsLast: 'vs last time',
    recapNoComparison: 'First time on this day — no comparison yet.',
    recapNextWeight: 'Next time',
    recapMuscleUp: 'More',
    recapMuscleDown: 'Less',
    copyPrevious: 'Fill from last time',
    aiFeedback: 'AI feedback',
  },
  da: {
    appName: 'LiftLab',
    light: 'Lys',
    dark: 'Mørk',
    signOut: 'Log ud',
    logExercise: 'Log øvelse',
    advanced: 'RIR',
    exercisePlaceholder: 'Øvelse (f.eks. Bench Press)',
    reps: 'Reps',
    minutes: 'Min',
    trackingWeighted: 'Vægt',
    trackingTimed: 'Tid',
    min: 'min',
    kg: 'kg',
    rest: 'Pause (s)',
    rir: 'RIR',
    addSet: '+ Sæt',
    saveExercise: 'Gem øvelse',
    todaysWorkout: 'Dagens træning',
    finishWorkout: 'Afslut træning',
    workoutComplete: 'Træning fuldført',
    reopen: 'Genåbn',
    deleteWorkout: 'Slet',
    addSets: 'Tilføj sæt',
    addSet2: 'Tilføj sæt',
    history: 'Historik',
    exercises: 'øvelser',
    sets: 'sæt',
    workouts: 'Træninger',
    totalExercises: 'Øvelser',
    totalSets: 'Sæt',
    programBuilder: 'Programbygger',
    muscleGuide: 'Muskelkort',
    aiAnalysis: 'AI-analyse',
    progress: 'Fremskridt',
    bodyweight: 'Kropsvægt',
    bodyweightSubtitle: 'Log din vægt og se udviklingen over tid.',
    bodyweightRecent: 'Seneste',
    bodyweightEmpty: 'Ingen vægt logget endnu.',
    bodyweightGoal: 'Mål',
    bodyweightGoalType: 'Type',
    bodyweightGoalTarget: 'Målvægt',
    bodyweightGoalMaintain: 'Vedligehold',
    bodyweightGoalCut: 'Cut',
    bodyweightGoalBulk: 'Bulk',
    bodyweightGoalSave: 'Gem mål',
    bodyweightSave: 'Gem',
    activeProgram: 'Aktivt program — hvad træner du i dag?',
    logManually: 'Log manuelt i dag',
    removeProgram: 'Fjern program',
    editProgram: 'Rediger program',
    programSaved: 'Program gemt. Vælg en dag når du træner.',
    front: 'Forside',
    back: 'Bagside',
    topExercises: 'Top øvelser',
    addToHomeScreen: 'Tilføj til startskærm',
    selectWorkout: 'Vælg en tidligere træning',
    cancel: 'Annuller',
    loadPreviousWorkout: 'Indlæs tidligere træning',
    repsLabel: 'Plan:',
    prTrackerTitle: 'PR-tracker',
    prTrackerSubtitle: 'Dine seneste personlige rekorder.',
    prAdd: 'Tilføj',
    prClose: 'Luk',
    prThisWeek: 'Denne uge',
    prWeeklyGoal: 'Ugentligt mål',
    prUnit: 'PRs',
    prNone: 'Ingen PRs endnu — fuldfør et sæt, så gemmer vi dine bedste løft.',
    prToastTitle: 'Ny personlig rekord',
    prDeleteAria: 'Slet PR',
    prFormExercise: 'Øvelse',
    prFormReps: 'reps',
    prFormSave: 'Gem',
    showMore: 'Vis flere',
    showLess: 'Vis færre',
    navTrain: 'Træn',
    navProgress: 'Fremskridt',
    navProgram: 'Program',
    saved: 'Gemt',
    saving: 'Gemmer…',
    incomplete: 'Ikke afsluttet',
    sessionTime: 'Tid',
    restTimer: 'Pause',
    skipRest: 'Spring over',
    defaultRest: 'Pause-timer',
    share: 'Del',
    shareFailed: 'Kunne ikke dele',
    addExercise: 'Tilføj øvelse',
    deleteExercise: 'Fjern øvelse',
    completeSet: 'Fuldfør sæt',
    uncompleteSet: 'Fortryd sæt',
    removeSet: 'Fjern sæt',
    previous: 'Sidst',
    set: 'Sæt',
    goBack: 'Tilbage',
    dragExercise: 'Træk for at flytte øvelse',
    primaryMuscle: 'Primær muskel',
    primaryMuscleOptional: 'Primær muskel (valgfri)',
    weeklyVolume: 'Ugentlig volume',
    vsLastWeek: 'vs sidste uge',
    noLastWeek: 'Ingen forrige uge at sammenligne',
    last7: '7 dage',
    last30: '30 dage',
    muscleDistribution: 'Muskelfordeling',
    setsPerMuscle: 'Sæt pr. muskel',
    muscleEmpty: 'Log et par sæt for at se hvordan træningen fordeler sig.',
    restDone: 'Pause slut — næste sæt',
    save: 'Gem',
    restDayLabel: 'Hviledag',
    currentProgram: 'Dit program',
    programSince: 'Gemt',
    trainingToday: 'I dag',
    trainThisDay: 'Træn denne dag',
    replaceProgram: 'Byg et nyt program',
    exerciseProgress: 'Progression pr. øvelse',
    viewProgram: 'Program',
    changeDay: 'Skift dag',
    searchGoogle: 'Søg på Google',
    guideStart: 'Start',
    guideMid: 'Midt',
    guideEnd: 'Slut',
    guideEquipment: 'Udstyr',
    guideCredit: 'Øvelsesillustrationer af Everkinetic, udvidet af Bryl Lim, CC BY-SA 4.0.',
    recapVsLast: 'vs sidste gang',
    recapNoComparison: 'Første gang på denne dag — intet at sammenligne med endnu.',
    recapNextWeight: 'Næste gang',
    recapMuscleUp: 'Mere',
    recapMuscleDown: 'Mindre',
    copyPrevious: 'Udfyld fra sidste gang',
    aiFeedback: 'AI-feedback',
  },
};

export default translations;
